import debounce from 'lodash/debounce';
import KeenSlider from 'keen-slider';

function ThumbnailPlugin(main) {
	return (slider) => {
	  function removeActive() {
		slider.slides.forEach((slide) => {
		  slide.classList.remove("active")
		})
	  }
	  function addActive(idx) {
		slider.slides[idx].classList.add("active")
	  }

	  function addClickEvents() {
		slider.slides.forEach((slide, idx) => {
		  slide.addEventListener("click", () => {
			main.moveToIdx(idx)
		  })
		})
	  }

	  slider.on("created", () => {
		addActive(slider.track.details.rel)
		addClickEvents()
		main.on("animationStarted", (main) => {
		  removeActive()
		  const next = main.animator.targetIdx || 0
		  addActive(main.track.absToRel(next))
		  // slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
		})
	  })
	}
}
document.addEventListener('DOMContentLoaded', function() {
	var expertSlider = new KeenSlider("#expert-gallery");
	var thumbnails = new KeenSlider(
		"#expert-gallery-thumbs",
		{
			vertical: true,
		},
		[ThumbnailPlugin(expertSlider)]
	);

});

  
